import { FC } from 'react';
import Button from 'components/base/Button';
import ResultPage from 'components/ResultPage';
import UI from 'stores/ui';
import API from 'utils/API';
import { ESOP_OPEN_ACCOUNT_REDIRECT } from 'utils/constants';

const Complete: FC = () => {
    return (
        <div className="open-complete-root">
            <ResultPage
                className="mb-3"
                status="SUCCESS"
                contentOptions={{
                    text: __(
                        'Congratulations! Your application has been submitted successfully. Please wait patiently for the account opening result.'
                    )
                }}
                btnOptions={{
                    show: false
                }}
            />
            <Button
                href={
                    sessionStorage.getItem(ESOP_OPEN_ACCOUNT_REDIRECT) || (UI.isMobile ? API.ESOP.m() : API.ESOP.web())
                }
                block
                type="primary"
                size="lg">
                {__('Return to the ESOP')}
            </Button>
        </div>
    );
};

export default Complete;
